// extracted by mini-css-extract-plugin
module.exports = {"smallSwitch":"Switch_smallSwitch__iEk9N"};